<script>
import ExportIcon from "@/icons/ExportIcon.vue";
import apiClient from "@/api/api-client";
import { getUsers } from "@/api/users";
import { languages } from "@/api/common";

export default {
  name: "MarkedFilesReportsList",
  components: { ExportIcon },
  data() {
    return {
      markedFilesDate: null,
      selectedAnnotator: null,
      selectedLang: null,
      annotatedFiles: [],
      loading: false,
      users: [],
      total_duration: 0,
      total: 0,
      page: 1,
      limit: 20,
    };
  },
  computed: {
    domain() {
      return window.domain;
    },
    batchLanguages() {
      return languages();
    },
  },
  async created() {
    await this.getAnnotatedFiles();
    this.users = (await getUsers({ role: "annotator" })) || [];
  },
  methods: {
    async getAnnotatedFiles() {
      this.loading = true;
      try {
        let params = {
          annotator_id: this.selectedAnnotator,
          lang: this.selectedLang,
          page: this.page,
          limit: this.limit,
        };
        if (this.markedFilesDate && this.markedFilesDate.length > 0) {
          params.start_date = this.markedFilesDate[0];
          params.stop_date = this.markedFilesDate[1];
        }
        const response = await apiClient.get("/export/annotated_files", {
          params,
        });
        if (response && response.data) {
          this.annotatedFiles = response.data.data || [];
        }
        if (response && response.data && response.data.totals) {
          this.total = response.data.totals.count;
          this.total_duration = response.data.totals.duration_str;
        }
      } catch (error) {
        console.error(error);
      } finally {
        this.loading = false;
      }
    },
    changeFilterMarkedFiles() {
      this.page = 1;
      this.getAnnotatedFiles();
    },
    downloadFile(filename, fileUrl) {
      fetch(fileUrl)
        .then((response) => response.blob())
        .then((blob) => {
          const url = window.URL.createObjectURL(blob);

          const a = document.createElement("a");
          a.href = url;
          a.download = filename;
          document.body.appendChild(a);
          a.click();
          document.body.removeChild(a);
          window.URL.revokeObjectURL(url);
        })
        .catch((error) => {
          console.error(error);
        });
    },
    async downloadReport(endpoint, params = {}) {
      this.loading = true;
      try {
        const data = await apiClient.post(endpoint, params);

        if (data && data.data && data.data.output_path) {
          const fileUrl = `${this.domain}${data.data.output_path}`;
          this.downloadFile(data.data.file_name, fileUrl);
        } else {
          alert("Не успешно");
        }
      } catch (error) {
        console.log(error);
      } finally {
        this.loading = false;
      }
    },
    async downloadMarkedFiles() {
      const params =
        this.markedFilesDate &&
        this.markedFilesDate[0] &&
        this.markedFilesDate[1]
          ? {
              start_date: this.markedFilesDate[0],
              stop_date: this.markedFilesDate[1],
              ...(this.selectedAnnotator && {
                annotator_id: this.selectedAnnotator,
              }),
            }
          : this.selectedAnnotator
          ? { annotator_id: this.selectedAnnotator }
          : {};

      await this.downloadReport("/export/annotated_files", params);
    },
    handleChangePage(page) {
      this.page = page;
      this.getAnnotatedFiles();
    },
    trimMilliseconds(dateTimeStr) {
      if (!dateTimeStr) {
        return "";
      }
      return dateTimeStr.split(".")[0];
    },
  },
};
</script>

<template>
  <div class="mng-page flex flex-col h-full w-full">
    <div class="mng-page__header flex-shrink-0">
      <div class="mng-page__title-row">
        <div class="flex flex-col">
          <h1 class="mng-page__title">Размеченные файлы · {{ total }}</h1>
          <div class="flex items-center mt-1">
            <div class="text-gray-500">Общая длительность:</div>
            <div class="ml-1.5">
              <el-tag round>{{ total_duration }}</el-tag>
            </div>
          </div>
        </div>
      </div>
      <div class="mng-page__filters">
        <div class="flex flex-wrap items-center justify-end gap-3">
          <el-date-picker
            v-model="markedFilesDate"
            value-format="YYYY-MM-DD"
            type="daterange"
            placeholder="Дата"
            style="max-width: 200px; margin-right: 10px"
            @change="changeFilterMarkedFiles"
          ></el-date-picker>
          <el-select
            v-model="selectedAnnotator"
            clearable
            filterable
            placeholder="Аннотатор"
            style="max-width: 200px; margin-right: 10px"
            @change="changeFilterMarkedFiles"
          >
            <el-option
              v-for="user in users"
              :key="user._id"
              :value="user._id"
              :label="`${user.first_name} ${user.last_name}`"
            ></el-option>
          </el-select>
          <el-select
            v-model="selectedLang"
            placeholder="Язык"
            @change="changeFilterMarkedFiles"
            clearable
            style="max-width: 200px; margin-right: 10px"
          >
            <el-option
              v-for="language in batchLanguages"
              :label="language.title"
              :value="language.value"
              :key="language.value"
              >{{ language.title }}</el-option
            >
          </el-select>
          <el-button
            @click="downloadMarkedFiles"
            :disabled="loading"
            type="success"
            plain
            class="download_button"
          >
            <export-icon></export-icon>
            Скачать xlsx</el-button
          >
        </div>
      </div>
    </div>
    <main
      class="mng-page__body flex-1 min-h-0 flex flex-col overflow-hidden"
      style="padding: 20px 26px"
    >
      <el-table
        :data="annotatedFiles"
        v-loading="loading"
        border
        stripe
        height="100%"
        style="width: 100%; overflow-y: auto"
      >
        <el-table-column
          type="index"
          label="№"
          width="90"
          align="center"
          fixed="left"
        ></el-table-column>
        <el-table-column prop="_id" label="ID" width="240"></el-table-column>
        <el-table-column
          prop="topic"
          label="Имя батча"
          min-width="200"
        ></el-table-column>
        <el-table-column
          prop="filename"
          label="Имя файла"
          min-width="240"
        ></el-table-column>
        <el-table-column
          prop="duration_utterances"
          label="Длительность фрагментов"
          min-width="240"
        ></el-table-column>
        <el-table-column prop="lang" label="Язык" width="150"></el-table-column>
        <el-table-column
          prop="annotator_finish"
          label="Дата завершения разметки"
          min-width="240"
        >
          <template #default="scope">
            {{ trimMilliseconds(scope.row.annotator_finish) }}
          </template>
        </el-table-column>
        <el-table-column
          prop="status"
          label="Статус"
          min-width="240"
        ></el-table-column>
        <el-table-column
          prop="display_name"
          label="Аннотатор"
          min-width="240"
        ></el-table-column>
      </el-table>
      <div class="mt-3 flex justify-center">
        <el-pagination
          v-if="total > 20"
          background
          layout="pager"
          :total="total"
          :current-page="page"
          @update:current-page="handleChangePage"
          :page-size="limit"
        />
      </div>
    </main>
  </div>
</template>

<style scoped lang="scss">
@import "@/assets/manage-page.scss";
</style>
